function ___$insertStyle(css) {
    if (!css || typeof window === 'undefined') {
        return;
    }
    const style = document.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    document.head.appendChild(style);
    return css;
}

var facebook = {
  "id": "facebook",
  "symbol": "<symbol id=\"facebook\" viewBox=\"0 0 27 27\" style=\"fill: currentColor\"><path d=\"M25.92 0H1.08C0.482625 0 0 0.482625 0 1.08V25.92C0 26.5174 0.482625 27 1.08 27H25.92C26.5174 27 27 26.5174 27 25.92V1.08C27 0.482625 26.5174 0 25.92 0ZM22.8015 7.88063H20.6449C18.954 7.88063 18.6266 8.68388 18.6266 9.86512V12.4672H22.6631L22.1366 16.5409H18.6266V27H14.418V16.5443H10.8979V12.4672H14.418V9.4635C14.418 5.97712 16.5476 4.077 19.6594 4.077C21.1511 4.077 22.4303 4.18838 22.8049 4.239V7.88063H22.8015Z\" /></symbol>"
};

export { facebook };
